define('bindingHandlers/datePicker2',[
    'lib/knockout',
    'jquery',
    'bindingHandlers/util/datePickerUtil',

    'lib/bootstrap-datetimepicker'
], function (ko,
             $,
             datePickerUtil) {
    "use strict";


    /**
     * Date Time Picker (Bootstrap)
     *
     * This binding handler will allow for a more robust approach to picking a date, month, year, time, etc...
     * Uses Bootstrap 3, dependant on Moment and jQuery.
     *
     * # Required
     * MUST BE AN INPUT for single date time picker
     * value {Observable} - String
     *
     * #Options
     *      timeZone {boolean} = default false; set to true should get the client timezone (pending Moment update)
     *      isTodayMaxDate {boolean} = default false; when set to true uses today as max date
     *      useClientLocale {boolean} = default false; when set to true used the client locale value to pass on to moment
     *      format {string} = will determine which components are shown; uses moments formatting for display
     *                          as an example: using format: 'MM/YYYY' will display a string '07/2015'. Likewise using format
     *                          "hh:mm:ss" will show "04:23:23".
     *      viewMode {string} = will determine which view should be displayed when the picker is rendered
     *                          i.e. viewMode: 'months' will start with months being shown, 'years' will show years, etc...
     *      tooltipPlacement = default "default", can be set to top or bottom to keep toolbar in place; default will slide the
     *                          toolbar up or down
     *      timeZone {boolean} = default false; set to true this will apply the client's timezone to moment
     *
     * Minimum usage:
     * <input type="button" data-bind= "datePicker2: {
     *                          value: dateObservable,
     *                          options: {
     *                              useClientLocale: true <----- Must be set to true for datePicker2, until original datePicker is removed
     *                                                           this is to support backwards compatibility when using datePickerUtil
     *                              }
     *                          }" />
     *
     * Example usage with viewMode:
     * <input type="button" data-bind= "datePicker2: {
     *                      value: dateObservable,
     *                      options: {
     *                          useClientLocale: true,
     *                          viewMode: 'months',     <----- will start picker at months and not show days
     *                          isTodayMax: true,       <----- will use today as max date selectable
     *                          format: 'MM/DD/YYYY'    <----- will display date in input as shown,
     *                          timeZone: true          <----- will use moment to get the timezone and apply offsets
     *                      }
     *                   }" />
     *
     * Time Picking using format option:
     * <div class="input-group date-range2-container">
     *      <span class="input-group-addon fa fa-calendar"></span>
     *      <input type="button" class="form-control" data-bind="
     *          datePicker2: {
     *              value: dateObservable,
     *              options: {
     *                  useClientLocale: true,
     *                  timeZone: true,
     *                  toolbarPlacement: 'bottom',
     *                  format: 'hh:mm:ss zz'       <---- will only allow a user to select hours, minutes, seconds,
     *                                                  additionally will show current time zone in "EST"-like format
     *              }
     *           }
     *      "/>
     *</div>
     *
     *
     * Use with Bootstrap input group:
     * <div class="input-group date-range2-container">
     *      <span class="input-group-addon fa fa-calendar"></span>
     *      <input type="button" class="form-control" data-bind= "datePicker2: {
     *                      value: dateObservable,
     *                      options: {
     *                          useClientLocale: true,
     *                          viewMode: 'months', <----- will start picker at months and not show days
     *                          isTodayMax: true,
     *                          format: 'MM/YYYY'   <----- will display date in input as shown,
     *                          timeZone: true      <----- will use moment to get the timezone and apply offsets
     *                      }
     *                   }" />
     * </div>
     */
    ko.bindingHandlers.datePicker2 = {
        init: function (element, valueAccessor) {
            //initialize datepicker with some optional options
            var bindingData = valueAccessor() || {};

            var options = datePickerUtil.processOptions(bindingData);

            $(element).datetimepicker(options);

            //when a user changes the date, update the view model
            ko.utils.registerEventHandler(element, "dp.change", function (event) {
                var bindings = valueAccessor();
                var value = bindings.value;

                if (ko.isObservable(value)) {
                    value(event.date);
                }
            });

            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                var picker = $(element).data("DateTimePicker");
                if (picker) {
                    picker.destroy();
                }
            });
        },
        update: function (element, valueAccessor) {
            var picker = $(element).data("DateTimePicker");
            //when the view model is updated, update the widget
            if (picker) {
                var date = ko.utils.unwrapObservable(valueAccessor().value());

                picker.date(date);

                if (valueAccessor().observableTimeZone) {
                    var timeZone = ko.utils.unwrapObservable(valueAccessor().observableTimeZone());
                    picker.timeZone(timeZone);
                }
            }
        }
    };
});

